
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.598 6L9.51 9.917c2.548 1.444 3.625 1.444 6.174 0L22.598 6","stroke":"#fff","stroke-width":"1.5","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M2.613 13.476c.066 3.065.098 4.598 1.23 5.733 1.13 1.136 2.705 1.175 5.853 1.254 1.941.05 3.862.05 5.803 0 3.148-.079 4.723-.118 5.854-1.254 1.13-1.135 1.164-2.668 1.229-5.733.021-.986.021-1.966 0-2.952-.065-3.065-.098-4.598-1.23-5.733-1.13-1.136-2.705-1.175-5.853-1.254-1.94-.05-3.862-.05-5.803 0-3.148.079-4.722.118-5.853 1.254-1.132 1.135-1.164 2.668-1.23 5.733a69.066 69.066 0 000 2.952z","stroke":"#fff","stroke-width":"1.5","stroke-linejoin":"round"}})])
          )
        }
      }
    